/* eslint-disable prefer-destructuring */
/* eslint-disable no-alert */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-const */

import React, { useContext, useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import firebase from 'firebase/app';
import { useSnackbar } from 'notistack';

import PATH from 'routes/path';

import { AuthContext } from 'providers/AuthProvider';

import Header from 'pages/Home/Header';
import StepItems from 'pages/Home/StepItems';
import GetOutModal from 'pages/Home/GetOutModal';
import HelperModal from 'pages/Home/HelperModal';
import RecoverPhoneModal from 'pages/Home/RecoverPhoneModal';
import ChangePhoneNumber from 'pages/Home/ChangePhoneNumber';

import { acceptEula } from 'services/api/eula';
import { getCaseById } from 'services/api/cases';
import { createEventTracking } from 'services/api/tracking';
import { firebaseErrors } from 'services/api/firebaseErrors';
import { getCustomers, updateCustomer } from 'services/api/customers';

import Loading from 'components/Loading';
import { ALERT_TYPE } from 'components/Alert';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

// import axios from 'axios';
import MissingCodeModal from './MissingCodeModal';
import ShareModal from './ShareModal';
import { Container } from './styles';

// Página inicial (Home)
const Home = () => {
  const { currentUser } = useContext(AuthContext);
  const [currentNumber, setCurrentNumber] = useState('');
  const [newNumber, setNewNumber] = useState('');
  const [verificationId, setVerificationId] = useState('');
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);
  const [openHelper, setOpenHelper] = useState(false);
  const [recoverPhone, setRecoverPhone] = useState(false);
  const [openRecoverPhone, setOpenRecoverPhone] = useState(false);
  const [openMissingModal, setMissingModal] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [stepUser, setStepUser] = useState(0);
  const [idCase, setIdcase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [stageItems, setStageItems] = useState([
    {
      title: 'Calcular valor da revisão',
      info: 'Envie seus Extratos do FGTS e veja o valor (R$) calculado para a sua correção',
      path: PATH.CALCULATION,
      status: 'incomplete',
      dataIntercomTarget: 'stage-user-data',
      link: true,
    },
    {
      title: 'Informar dados para o pedido',
      info: 'Preencha com as suas informações para o sistema gerar o documento de entrada do pedido',
      path: PATH.USER_DATA,
      status: 'disabled',
      dataIntercomTarget: 'stage-calculation',
    },
    {
      title: 'Contratar KIT ou Serviço de Atermação',
      info: 'Busque seu direito, escolhendo entre o KIT de documentos e nosso serviço de apoio para protocolo do pedido no Juizado Especial Federal',
      path: PATH.PAYMENT,
      status: 'disabled',
      dataIntercomTarget: 'stage-payment',
    },
    {
      title: 'Documentos e pedido de revisão',
      info: 'Confira os documentos e os procedimentos para entrar com o seu pedido',
      path: PATH.DOCUMENTS,
      status: 'disabled',
      dataIntercomTarget: 'stage-documents',
    },
    {
      title: 'Download do Kit',
      info: 'Pronto! Dúvidas sobre como dar entrada no processo? Acesse a central de ajuda',
      path: PATH.DOWNLOAD,
      status: 'disabled',
      dataIntercomTarget: 'stage-download',
    },
  ]);
  const { enqueueSnackbar } = useSnackbar();

  const scope = new Sentry.Scope();

  // Aceita termos de uso
  const acceptingEula = async (id) => {
    try {
      await acceptEula(id);
    } catch (error) {
      // console.error(error);
      enqueueSnackbar('Ocorreu um erro ao aceitar os termos de uso.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage id={key} message={message} variant={ALERT_TYPE.ERROR} />
        ),
      });
    }
  };

  // Carrega os dados do usuário (customer)
  const loadCustomer = async () => {
    try {
      const { data } = await getCustomers();
      setUser(data[0]);

      if (localStorage.idEula) {
        acceptingEula(localStorage.idEula);
        localStorage.idEula = '';
      }

      const isAssecivil = localStorage.origin === 'assecivil';

      if (data[0].meta_data && Object.keys(data[0].meta_data).length) {
        if (data[0].meta_data.idCase) {
          const newData = await getCaseById(data[0].meta_data.idCase);

          if (newData.data.payment_method === 'pagseguro') {
            const newStageItems = stageItems;
            newStageItems[3].path = PATH.ATERMACAO;

            setStageItems(newStageItems);
          }
        }

        if (data[0].meta_data.calculatedValue) {
          localStorage.setItem(
            'calculated_value',
            data[0].meta_data.calculatedValue,
          );
        }
        data[0].meta_data.idCase && setIdcase(data[0].meta_data.idCase);

        if (data[0].meta_data.idFgts) {
          let newArr = [...stageItems];
          newArr[0].path = `/resultado/${parseInt(data[0].meta_data.idFgts)}`;
          setStageItems(newArr);
        }

        if (!data[0].meta_data.registrationFb) {
          fbq('track', 'CompleteRegistration', {
            name: data[0].full_name && data[0].full_name,
            email: data[0].email && data[0].email,
            phone: data[0].cel_phone && data[0].cel_phone,
            content_name: window.location.pathname + window.location.search,
            status: true,
          });
          const payload = {
            ...data[0],
            meta_data: {
              ...data[0].meta_data,
              registrationFb: true,
              origin: isAssecivil ? 'assecivil' : '',
            },
          };
          await updateCustomer(data[0].id, payload);
        }

        if (isAssecivil) {
          window.Intercom('trackEvent', 'LOIT FGTS cadastro assecivil');
          localStorage.setItem('origin', '');
        }

        if (data[0].meta_data.step <= 3 && data[0].meta_data.idCase) {
          const dataCase = await getCaseById(data[0].meta_data.idCase);
          if (!dataCase.data.is_paid) {
            setStepUser(data[0].meta_data.step);
          } else {
            const payload = {
              ...data[0],
              meta_data: {
                ...data[0].meta_data,
                step: 3,
                paidOut: true,
                newFgts: false,
                method_payment: dataCase.data.payment_method,
              },
            };
            if (window.localStorage.getItem('checkout_pagseguro')) {
              window.localStorage.removeItem('checkout_pagseguro');
            }
            await updateCustomer(data[0].id, payload);
            setStepUser(3);
          }
        } else {
          data[0].meta_data.step && setStepUser(data[0].meta_data.step);
        }
      }

      setLoading(false);
    } catch (error) {
      const { response } = error;
      if (response) {
        if (response.status === 403) {
          setTimeout(() => {
            loadCustomer();
          }, 3000);
        }
      } else {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    const onPageLoad = async () => {
      document.title = 'Página inicial - Revisão FGTS - LOIT';
      window.Intercom('trackEvent', 'LOIT FGTS home');

      loadCustomer();

      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        'recaptcha-container',
        { size: 'invisible' },
      );

      setTimeout(async () => {
        if (localStorage.events) {
          const { events } = localStorage;
          for (let index = 0; index < JSON.parse(events).length; index++) {
            createEventTracking(JSON.parse(events)[index]);
            if (index + 1 === JSON.parse(events).length) { localStorage.events = []; }
          }
        }
      }, 3000);
    };

    onPageLoad();
  }, []);

  useEffect(() => {
    for (let index = 0; index <= stepUser; index++) {
      let newArr = [...stageItems];
      if (index <= stepUser - 1) newArr[index].status = 'completed';
      if (stepUser < 5 && index + 1 === stepUser) { newArr[index + 1].status = 'incomplete'; }
      setStageItems(newArr);
    }
  }, [stepUser]);

  const handleCopyText = () => {
    setOpenShareModal(false);
    enqueueSnackbar('Link copiado com sucesso!', {
      ...OPTIONS,
      content: (key, message) => (
        <SnackMessage id={key} message={message} variant={ALERT_TYPE.SUCCESS} />
      ),
    });
    createEventTracking('200 - compartilhamento');
  };

  useEffect(() => {
    recoverPhone && createEventTracking('210 - alterar celular');
  }, [recoverPhone]);

  // Reseta container do reCAPTCHA
  const resetRecaptcha = () => window.recaptchaVerifier.reset();

  const closeModal = () => {
    setOpenRecoverPhone(false);
    resetRecaptcha();
  };

  const closeMissingModal = () => {
    setMissingModal(false);
    resetRecaptcha();
  };

  const showMissingModal = () => {
    if (openRecoverPhone) setOpenRecoverPhone(false);
    setMissingModal(true);
  };

  const clearData = (update = false) => {
    setCurrentNumber('');
    setNewNumber('');
    setVerificationId('');
    setOpenRecoverPhone(false);
    !update && setRecoverPhone(false);
  };

  const updatePhoneNumber = async (code) => {
    try {
      const payload = { ...user };
      await updateCustomer(user.id, payload);
      const credential = await firebase.auth.PhoneAuthProvider.credential(
        verificationId,
        code,
      );
      await firebase.auth().currentUser.updatePhoneNumber(credential);
      await createEventTracking('220 - alteração de celular efetuada');

      enqueueSnackbar('Alteração de celular concluída!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.SUCCESS}
          />
        ),
      });
      clearData(true);
      window.Intercom('update', {
        name: currentUser.displayName && currentUser.displayName,
        phone: newNumber && formatNumber(newNumber),
        user_id: newNumber && `loit_fgts_${formatNumber(newNumber)}`,
        user_hash:
          localStorage.getItem('user_hash')
          && localStorage.getItem('user_hash'),
      });
    } catch (error) {
      scope.setContext('character', {
        name: currentUser.displayName && currentUser.displayName,
        phone: currentUser.phoneNumber && currentUser.phoneNumber,
        email: currentUser.email && currentUser.email,
      });
      scope.setContext('payload', {
        newNumber,
        verificationId,
        code,
      });
      Sentry.captureException(new Error('error updating phone'), () => scope);
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    }
  };

  // Reenvio do código de confirmação
  const retryVerification = async () => {
    closeMissingModal();
    const appVerifier = window.recaptchaVerifier;

    const provider = new firebase.auth.PhoneAuthProvider();
    await provider
      .verifyPhoneNumber(newNumber, appVerifier)
      .then(async (IdVerification) => {
        setVerificationId(IdVerification);
        setOpenRecoverPhone(true);
      })
      .catch((error) => {
        if (error.code) {
          enqueueSnackbar(firebaseErrors[error.code], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
        }
        resetRecaptcha();
      });
  };

  return (
    <Container recoverPhone={recoverPhone}>
      {loading && <Loading bg="white" />}
      <GetOutModal open={open} onClose={setOpen} />
      <HelperModal open={openHelper} onClose={setOpenHelper} />
      <RecoverPhoneModal
        open={openRecoverPhone}
        onClose={closeModal}
        phone={newNumber}
        updatePhoneNumber={updatePhoneNumber}
        showModal={showMissingModal}
      />
      <MissingCodeModal
        phone={newNumber}
        open={openMissingModal}
        retry={retryVerification}
        onClose={closeMissingModal}
      />
      {openShareModal && (
        <ShareModal
          open={openShareModal}
          onClose={setOpenShareModal}
          handleCopyText={handleCopyText}
          clearData={() => clearData()}
        />
      )}
      <Header
        currentUser={currentUser}
        stepUser={stepUser}
        recoverPhone={recoverPhone}
        setRecoverPhone={setRecoverPhone}
        open={open}
        setOpen={setOpen}
        setOpenHelper={setOpenHelper}
        shareModal={setOpenShareModal}
        clearData={() => clearData()}
      />
      {recoverPhone ? (
        <ChangePhoneNumber
          currentUser={currentUser}
          user={user}
          updateUser={setUser}
          recoverPhoneModal={setOpenRecoverPhone}
          currentNumber={currentNumber}
          setCurrentNumber={setCurrentNumber}
          newNumber={newNumber}
          setNewNumber={setNewNumber}
          setVerificationId={setVerificationId}
          reset={() => clearData()}
        />
      ) : (
        <StepItems stageItems={stageItems} idCase={idCase} />
      )}
      <div id="recaptcha-container" />
    </Container>
  );
};

export default Home;
